require('./leagueLookInController');

"use strict";

angular.module('app.shared.leagueLookIn.leagueLookInDirective', [
  'app.shared.leagueLookIn.leagueLookInController'
])
    .directive('leagueLookIn', [
      '$window',
      function ($window) {
        return {
          restrict: 'E',
          templateUrl: 'components/shared/leagueLookIn/leagueLookInView.html',
          controller: 'app.shared.leagueLookIn.leagueLookInController',
          scope: {
            activeGame: '<',
            changeFeed: '<'
          },
          link: (scope, element) => {
            let widthChanged = () => {
              if (!element.hasClass('ng-hide')) {
                let width = element.width();

                if (width >= 974) {
                  scope.gamesPerSlide = 6;
                }
                else if (width >= 791) {
                  scope.gamesPerSlide = 5;
                }
                else if (width >= 737) {
                  scope.gamesPerSlide = 4;
                }
                else if (width >= 411) {
                  scope.gamesPerSlide = 3;
                }
                else {
                  scope.gamesPerSlide = 2;
                }
              }
            };

            angular.element($window).bind('resize', () => {
              scope.$applyAsync(() => {
                widthChanged();
              });
            });

            widthChanged();
          }
        }
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/leagueLookIn/leagueLookInDirective.js